// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__16AOO","content":"LoadingAlert_content__clldA"};